import { render, staticRenderFns } from "./HistoryResults.vue?vue&type=template&id=232f5bae&scoped=true&"
import script from "./HistoryResults.vue?vue&type=script&lang=js&"
export * from "./HistoryResults.vue?vue&type=script&lang=js&"
import style0 from "./HistoryResults.vue?vue&type=style&index=0&id=232f5bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232f5bae",
  null
  
)

export default component.exports